<template lang="pug">
MarqueeText(:repeat="repeat" :duration="duration")
  | {{text}}
</template>

<script>
import MarqueeText from 'vue-marquee-text-component'

export default {
  name: 'Ticker',
  components: {
    MarqueeText
  },
  computed: {
    text () {
      return window.TICKERTEXT
    },
    repeat () {
      if (window.TICKERREPEAT) {
        return window.TICKERREPEAT
      }
      return 30
    },
    duration () {
      if (window.TICKERDURATION) {
        return window.TICKERDURATION
      }
      return 10
    }
  }
}
</script>
